module.exports = __webpack_public_path__ + "img/landing-streaming.68adad14.png";